var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 26.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16,17.18V0h-2v17.18c-1.16.41-2,1.51-2,2.82,0,1.66,1.34,3,3,3s3-1.34,3-3c0-1.3-.84-2.4-2-2.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23,17.73v1.18c3.48.68,5.75,1.79,5.75,3.04,0,2.07-6.16,3.75-13.75,3.75s-13.75-1.68-13.75-3.75c0-1.26,2.27-2.36,5.75-3.04v-1.18c-4.2.89-7,2.44-7,4.22,0,2.76,6.72,5,15,5s15-2.24,15-5c0-1.78-2.8-3.34-7-4.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.15,17.7l-4.56-2.63-.5.87,4.65,2.68c.11-.32.24-.63.41-.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.26,18.62l4.65-2.68-.5-.87-4.56,2.63c.17.29.31.59.41.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.5,20c0,.34-.05.68-.12,1h5.62v-1h-5.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.98,16l-2.55-4.41-.87.5,2.58,4.46c.26-.21.54-.4.84-.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.86,16.55l2.58-4.46-.87-.5-2.55,4.41c.3.15.58.34.84.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.5,20h-5.5v1h5.62c-.07-.32-.12-.66-.12-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelt);
export default __webpack_public_path__ + "static/media/melt.4a852c7e9de15ce639a3d05f693a0e13.svg";
export { ForwardRef as ReactComponent };